module.exports = __webpack_public_path__ + "static/ProductHeaderTest.fa24cb08.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/ProductHeaderTest.png
// module id = 1452
// module chunks = 168707334958949